var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn-toolbar',{staticClass:"layers-toolbar"},[_c('span',{staticClass:"text-center version-info"},[_vm._v("Wersja: "+_vm._s(_vm.version))])])
}
var staticRenderFns = []

export { render, staticRenderFns }